<template>
<div class="mt-5">

  <page-title> Create a new Project </page-title>
  <v-snackbar v-model="snackbar" :color="color" :multi-line="mode === 'multi-line'" :timeout="timeout" :vertical="mode === 'vertical'">
    {{ text }}
    <v-btn dark flat @click="snackbar = false">
      <v-icon>cancel</v-icon>
    </v-btn>
  </v-snackbar>
  <v-stepper v-model="active" vertical>
    <v-stepper-step color="green" :complete="active > 1" step="1">
      What is the name of the project?
    </v-stepper-step>

    <v-stepper-content step="1">
      <v-card flat tile class="mb-2">
        <v-card-text>
          <v-text-field color="green" class="form-input" type="text" v-model="projectTitle" placeholder="Project or Team Name" name="projectTitle" v-validate="'required'" />
          <span style="color: red;">{{ errors.first("projectTitle") }}</span>
          <div class="form-group">
            <v-switch v-model="hasExtraInfo" color="green" label="Would you like to add a description?" type="checkbox"></v-switch>
          </div>
          <div v-show="hasExtraInfo" key="input" class="input-group">
            <transition name="transition" enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutUp">
              <markdown-editor class="text-xs-left" color="green" v-show="hasExtraInfo" v-model="extraInfo" :configs="configs" />
            </transition>
          </div>
        </v-card-text>
      </v-card>
      <v-btn color="green" dark @click="active = 2">Continue</v-btn>
    </v-stepper-content>

    <v-stepper-step color="green" :complete="active > 2" step="2">When does team meet/check-in?</v-stepper-step>

    <v-stepper-content step="2">
      <v-card flat tile class="mb-5">
        <v-card-text class="text-xs-left">
          <div class="btn-group btn-group-block">
            <v-switch color="green" label="Monday" @click="toggle('monday');" :class="meetingDays.monday ? 'active' : ''" class="btn d-inline-block">
            </v-switch>
            <v-switch color="green" label="Tuesday" @click="toggle('tuesday');" :class="meetingDays.tuesday ? 'active' : ''" class="btn d-inline-block ml-2">
            </v-switch>
            <v-switch color="green" label="Wednesday" @click="toggle('wednesday');" :class="meetingDays.wednesday ? 'active' : ''" class="btn d-inline-block ml-2">
            </v-switch>
            <v-switch color="green" label="Thursday" @click="toggle('thursday');" :class="meetingDays.thursday ? 'active' : ''" class="btn d-inline-block ml-2">
            </v-switch>
            <v-switch color="green" label="Friday" @click="toggle('friday');" :class="meetingDays.friday ? 'active' : ''" class="btn d-inline-block ml-2">
            </v-switch>
          </div>

          <br />
          <div class="time-group">
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <v-text-field color="green" label="Start time" type="time" format="ampm" class="time-picker form-input" v-model="meetingTime[0]" />
                <!--
                <v-time-picker color="green" width="190" v-model="meetingTime[0]" format="ampm"></v-time-picker>
              -->
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field color="green" label="End time" type="time" format="ampm" class="time-picker form-input" v-model="meetingTime[1]" />
                <!--
                <v-time-picker color="green" width="190" v-model="meetingTime[1]" format="ampm"></v-time-picker>
              -->
              </v-flex>
            </v-layout>
            <!-- <v-text-field color="green" type="time" class="time-picker form-input" v-model="meetingTime[0]" />
            <v-text-field color="green" type="time" class="time-picker form-input" v-model="meetingTime[1]" /> -->
          </div>
        </v-card-text>
      </v-card>
      <v-btn color="green" dark @click="active = 3">Continue</v-btn>
      <v-btn @click="active = 1" flat>Cancel</v-btn>
    </v-stepper-content>

    <v-stepper-step color="green" step="3">Where does the project meet?</v-stepper-step>
    <v-stepper-content step="3">
      <v-card flat tile class="mb-5">
        <v-card-text>

          <v-text-field color="green" class="form-input" type="text" v-model="location" name="location" v-validate="'required'" placeholder="Location" hint="(e.g. Webex, Hangouts, Coffee shop, etc.)" />
          <span style="color: red;">{{ errors.first("location") }}</span>
        </v-card-text>
      </v-card>
      <v-btn color="green" dark @click="next">Continue</v-btn>
      <v-btn @click="active = 1" flat>Cancel</v-btn>
    </v-stepper-content>

    <v-stepper-step color="green" step="4">Create New Project</v-stepper-step>
    <v-stepper-content step="4">
      <v-card class="mb-5">
        <v-card-text>
          <v-btn color="green" dark @click="createProjectSet" class="createBtn">
            Create Projects
          </v-btn>
        </v-card-text>
      </v-card>
      <v-btn @click="active = 1" flat>Cancel</v-btn>
    </v-stepper-content>
    <v-stepper-step color="green" step="5">Go to your dashboard</v-stepper-step>
    <v-stepper-content step="5">
      <v-card flat tile class="mb-5">
        <v-card-text>
          <div style="width: 50%; margin: 20px auto;" class="input-group">
            <v-text-field color="green" dark type="text" id="inviteDisplay" class="form-input" placeholder="Invite Code" v-model="inviteCode" style="margin: 0;" />
            <v-btn color="green" dark flat @click="copyCode" class="btn btn-success input-group-btn">
              Copy Code
            </v-btn>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn flat :to="{ name: 'dashboard' }">Dashboard</v-btn>
          <v-btn v-if="newGroupID" flat style="margin: 0px 10px;" :to="{ name: 'home', params: { groupID: newGroupID } }">Go to new board</v-btn>
        </v-card-actions>
      </v-card>
    </v-stepper-content>
  </v-stepper>
</div>
</template>

<script>
import VueMarkdown from 'vue-markdown'
import moment from 'moment'
import firebase, {
  db
} from "@/firebaseConfig";
import generateCode from "@/scripts/generateCode";
import PageTitle from "@/components/Shared/PageTitle";
export default {
  name: "CreateGroup",
  components: {
    PageTitle,
    VueMarkdown
  },
  data() {
    return {
      active: 0,
      projectTitle: "",
      location: "",
      hasExtraInfo: false,
      extraInfo: "",
      snackbar: false,
      mode: '',
      color: 'red darken-1',
      timeout: 6000,
      text: 'Message goes here',
      meetingDays: {
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false
      },
      meetingTime: [null, null],
      inviteCode: "",
      newGroupID: "",
      configs: {
        toolbar: ['bold', 'italic', 'heading', '|', 'ordered-list', 'unordered-list', '|', 'quote', 'horizontal-rule', '|', 'link', 'image', 'code']
      }
    };
  },
  methods: {
    toggle(key) {
      this.meetingDays[key] = !this.meetingDays[key];
    },
    next() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.active++;
        } else {
          this.text = 'All errors must be corrected.';
          this.color = 'red darken-1'
          this.snackbar = true;
        }
      });
    },
    back() {
      this.$validator.validateAll().then(result => {
        if (result && this.active !== 0) {
          this.active--;
        } else {
          this.text = 'All errors must be corrected.';
          this.color = 'red darken-1'
          this.snackbar = true;
        }
      });
    },
    copyCode() {
      // Allows user to copy the invite code on button click
      document.querySelector('#inviteDisplay').select();
      document.execCommand("copy");
    },
    getDaysArray() {
      let arr = [];
      Object.keys(this.meetingDays).forEach(key => {
        if (this.meetingDays[key] === true) {
          arr.push(key.charAt(0).toUpperCase() + key.slice(1));
        }
      });
      return arr;
    },
    createProjectSet() {
      // Generate random invite code and save it
      this.inviteCode = generateCode();
      // Create new group in the firestore
      db.collection("projects")
        .add({
          projectTitle: this.projectTitle,
          meetingDays: this.getDaysArray(),
          meetingTime: this.meetingTime,
          location: this.location,
          // Check to see if it is just the prepend or the actual url
          extraInfo: this.extraInfo,
          owner: firebase.auth().currentUser.uid,
          members: [firebase.auth().currentUser.uid],
          inviteCodes: [this.inviteCode]
        })
        .then(docRef => {
          this.newGroupID = docRef.id;
          this.next();
        })
        .catch(error => {
          this.text = 'CreateGroup: ' + error;
          this.snackbar = true;
          console.log("CreateGroup: " + error);
        });
    }
  },
  computed: {
    formattedURL() {
      return "https://" + this.websiteURL;
    }
  }
};
</script>

<style lang="scss" scoped>
button.s-circle {
    margin: 15px;
}

// Main container, centers all content on the page
.createContent {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

// Aligns the card into a row between the two traversal buttons.
.navContainer {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.infoContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    padding: 20px;
    min-height: 400px;
    width: 800px;
    background-color: rgb(255, 255, 255);
    border-radius: 4px;
    // border-radius: 16px;
    box-shadow: 5px 12px 20px rgba(36, 37, 38, 0.13);
}

.time-group {
    display: block;
}

.time-picker {
    width: 140px;
}

input {
    margin-top: 15px;
    margin-left: auto;
    margin-right: auto;
    width: 60%;
}

textarea {
    width: 60%;
}

.arrow-buttons {
    margin: 20px;
}

.blocked {
    cursor: not-allowed !important;
}

.switch {
    margin: 0 auto 20px;
    width: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/CreateGroup.vue